
import { SiriusBaseComponent } from 'sirius-framework';
import { Component, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { CommonService } from '../../shared/service/shared.service';
import { AccModelList } from '../../shared/models/shared.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

declare const $: any;

@Component({ 
    selector: 'own-accounts',
    templateUrl: './own-accounts.component.html',
    styleUrls: ['./own-accounts.component.css']
})
export class OwnAccountsComponent extends SiriusBaseComponent<any> {   
    @Output('OnSelect') onSelect = new EventEmitter<string>();

    @ViewChild("ownAccTemplate") ownAcctemp: TemplateRef<any>;
  modalRef: BsModalRef;
  noAccount: boolean = false;
    list: AccModelList;
  constructor(private commonService: CommonService,
    private modalService: BsModalService) {
        super();
    }
    OnInit() {
        var promise = this.commonService.GetUserOwnAccounts(this.dataService);
        promise.then((result: AccModelList) => {
            if (result != null && result.AccList != null) {
              this.list = result;
              if (this.list.AccList.length == 0)
                this.noAccount = true;
            }
            else {
              this.list = null;
              this.noAccount = true;
            }
        });
    }
    select(accNumber: string) {
        this.modalRef.hide();
        this.onSelect.emit(accNumber);
    }
    showPopup() {
      this.modalRef = this.modalService.show(this.ownAcctemp);
    }

  close() {
    this.modalRef.hide();
  }
}
